import { useTranslation } from 'react-i18next';

const useInputOptions = () => {
  const { t } = useTranslation();
  const TOPIC_OF_INTEREST = {
    default: {
      label: t('digitalLeads.inputs.topicOfInterest.chooseTopic'),
      key: 'default',
      value: '',
    },
    general: {
      label: t('digitalLeads.inputs.topicOfInterest.general'),
      key: 'general',
      value: 'general',
    },
    testDrive: {
      label: t('digitalLeads.inputs.topicOfInterest.testDrive'),
      key: 'testDrive',
      value: 'testDrive',
    },
    pricing: {
      label: t('digitalLeads.inputs.topicOfInterest.pricing'),
      key: 'pricing',
      value: 'pricing',
    },
    promotion: {
      label: t('digitalLeads.inputs.topicOfInterest.promotion'),
      key: 'promotion',
      value: 'promotion',
    },
    other: {
      label: t('digitalLeads.inputs.topicOfInterest.other'),
      key: 'other',
      value: 'other',
    },
  };

  const TIER3_TOPIC_OF_INTEREST = {
    default: {
      label: t('digitalLeads.inputs.topicOfInterest.chooseTopic'),
      key: 'default',
      value: '',
    },
    general: {
      label: t('digitalLeads.inputs.topicOfInterest.general'),
      key: 'general',
      value: 'general',
    },
    testDrive: {
      label: t('digitalLeads.inputs.topicOfInterest.testDrive'),
      key: 'testDrive',
      value: 'testDrive',
    },
    pricing: {
      label: t('digitalLeads.inputs.topicOfInterest.pricing'),
      key: 'pricing',
      value: 'pricing',
    },
    promotion: {
      label: t('digitalLeads.inputs.topicOfInterest.promotion'),
      key: 'promotion',
      value: 'promotion',
    },
    service: {
      label: t('digitalLeads.inputs.topicOfInterest.service'),
      key: 'service',
      value: 'service',
    },
    parts: {
      label: t('digitalLeads.inputs.topicOfInterest.parts'),
      key: 'parts',
      value: 'parts',
    },
    requestCall: {
      label: t('digitalLeads.inputs.topicOfInterest.requestCall'),
      key: 'requestCall',
      value: 'requestCall',
    },
    other: {
      label: t('digitalLeads.inputs.topicOfInterest.other'),
      key: 'other',
      value: 'other',
    },
  };

  const ALL_TOPIC_OF_INTEREST = {
    default: {
      label: t('digitalLeads.inputs.topicOfInterest.chooseTopic'),
      key: 'default',
      value: '',
    },
    general: {
      label: t('digitalLeads.inputs.topicOfInterest.general'),
      key: 'general',
      value: 'general',
    },
    testDrive: {
      label: t('digitalLeads.inputs.topicOfInterest.testDrive'),
      key: 'testDrive',
      value: 'testDrive',
    },
    pricing: {
      label: t('digitalLeads.inputs.topicOfInterest.pricing'),
      key: 'pricing',
      value: 'pricing',
    },
    promotion: {
      label: t('digitalLeads.inputs.topicOfInterest.promotion'),
      key: 'promotion',
      value: 'promotion',
    },
    service: {
      label: t('digitalLeads.inputs.topicOfInterest.service'),
      key: 'service',
      value: 'service',
    },
    parts: {
      label: t('digitalLeads.inputs.topicOfInterest.parts'),
      key: 'parts',
      value: 'parts',
    },
    requestCall: {
      label: t('digitalLeads.inputs.topicOfInterest.requestCall'),
      key: 'requestCall',
      value: 'requestCall',
    },
    other: {
      label: t('digitalLeads.inputs.topicOfInterest.other'),
      key: 'other',
      value: 'other',
    },
  };

  const PREFERRED_CONTACT_METHOD = {
    email: {
      label: t('digitalLeads.inputs.email'),
      key: 'email',
      value: 'email',
      ariaLabel: 'email',
    },
    text: {
      label: t('digitalLeads.inputs.text'),
      key: 'text',
      value: 'text',
      ariaLabel: 'text',
    },
    phone: {
      label: t('digitalLeads.inputs.phone'),
      key: 'phone',
      value: 'phone',
      ariaLabel: 'phone',
    },
  };

  const CONTACT_TIME = {
    default: {
      label: t('digitalLeads.inputs.preferredContactMethod.selectTime'),
      subLabel: '',
      key: 'default',
      value: 'NO_PREFERENCE',
      ariaLabel: 'default',
    },
    morning: {
      label: t('digitalLeads.inputs.preferredContactMethod.morning'),
      subLabel: '(9am - 12pm)',
      key: 'morning',
      value: 'MORNING',
      ariaLabel: 'morning',
    },
    afternoon: {
      label: t('digitalLeads.inputs.preferredContactMethod.afternoon'),
      subLabel: '(12pm - 5pm)',
      key: 'afternoon',
      value: 'AFTERNOON',
      ariaLabel: 'afternoon',
    },
    evening: {
      label: t('digitalLeads.inputs.preferredContactMethod.evening'),
      subLabel: '(5pm - 9pm)',
      key: 'evening',
      value: 'EVENING',
      ariaLabel: 'evening',
    },
  };

  return {
    TOPIC_OF_INTEREST,
    PREFERRED_CONTACT_METHOD,
    CONTACT_TIME,
    TIER3_TOPIC_OF_INTEREST,
    ALL_TOPIC_OF_INTEREST,
  };
};

export default useInputOptions;
